(() => {
  'use strict';
  const root = document.querySelector('[data-fp-theme]');
  const ask = root?.querySelector('[data-theme-ask]');
  if (!ask || !document.querySelector('[data-fp-assistant]')) return;
  ask.hidden = false;
  ask.setAttribute('aria-label', `Refine ${root.dataset.title} with Ask FivePoint`);
  ask.addEventListener('click', () => {
    const edits = [...root.querySelectorAll('[data-theme-edit-title]')].map(el => el.dataset.themeEditTitle).join(', ');
    document.dispatchEvent(new CustomEvent('fivepoint:assistant-compose', { detail: {
      text: `I'm exploring the "${root.dataset.title}" theme and its fabric edits: ${edits}. Help me refine these fabrics for my project: `,
      trigger: ask
    } }));
  });
  new IntersectionObserver(entries => {
    document.body.classList.toggle('fp-theme-cta-visible', entries[0].isIntersecting);
  }, { threshold: 0.5 }).observe(ask);
})();
